import { useState, useEffect } from 'react';

const useNoCacheOnServerFetchPolicy = () => {
  const [fetchPolicy, setFetchPolicy] = useState('no-cache');

  useEffect(() => {
    setFetchPolicy('cache-and-network');
  }, []);

  return fetchPolicy;
};

export default useNoCacheOnServerFetchPolicy;
